import * as Scrivito from 'scrivito';
import { ColumnWidgetAttributes, ColumnWidgetBackgroundColor, ColumnWidgetId } from './column-widget-definitions';
import { spacingClassAttributes } from '../../utils/scrivito/spacing-definitions';

const childWidgetIds = ['TextWidget', 'ImageWidget', 'VideoWidget', 'TableWidget', 'IconListWidget'];

export const ColumnWidgetClass = Scrivito.provideWidgetClass(ColumnWidgetId, {
  attributes: {
    [ColumnWidgetAttributes.ELEMENTS]: ['widgetlist', { only: childWidgetIds }],
    [ColumnWidgetAttributes.BACKGROUND_COLOR]: ['enum', { values: Object.values(ColumnWidgetBackgroundColor) }],
    ...spacingClassAttributes(),
  },
  extractTextAttributes: [ColumnWidgetAttributes.ELEMENTS],
});

export type ColumnWidget = InstanceType<typeof ColumnWidgetClass>;
